export function pushOrSplice(isSplice, permissions, permission) {
  if (isSplice) {
    const index = permissions.indexOf(permission)
    if (index > -1) {
      permissions.splice(index, 1)
    }
  } else {
    permissions.push(permission)
  }
}
